import React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {AuthProvider} from './AuthContext';
import Login from './components/Login';
import Logout from './components/Logout';
import Register from './components/Register';
import FileUpload from './components/FileUpload';
import Dashboard from './components/Dashboard';
import Forecast from './components/Forecast';
import Installments from './components/Installments';
import Expenses from './components/Expenses';
import Budgets from './components/Budgets';
import Subscriptions from './components/Subscriptions';
import {ProtectedLayout} from "./components/ProtectedLayout";
import Tags from "./components/Tags";
import Transfers from "./components/Transfers";
import TreemapView from './components/Treemap';

import './i18n';
import {Suspense} from 'react';
import {useTranslation} from 'react-i18next';

const LanguageSwitcher = () => {
  const {i18n} = useTranslation();

  const changeLang = (lng) => {
    i18n.changeLanguage(lng);
    try {
      localStorage.setItem('zenda_lang', lng);
    } catch (e) {
      // ignore if not available
    }
  };

  const containerStyle = {
    position: 'absolute',
    top: 12,
    right: 34, // moved left from 16
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    zIndex: 10000,
    background: 'transparent',
    fontFamily: 'sans-serif',
    fontSize: '13px',
    pointerEvents: 'auto'
  };

  const linkStyle = {
    border: 'none',
    background: 'transparent',
    padding: 0,
    cursor: 'pointer',
    color: '#007bff',
    textDecoration: 'none',
    fontWeight: 500,
    transition: 'color 0.2s ease'
  };

  const activeLangStyle = {
    textDecoration: 'underline',
    textDecorationThickness: '2px',
    fontWeight: '600',
    color: '#000',
  };

  const isEs = (i18n.resolvedLanguage || i18n.language || '').toLowerCase().startsWith('es');
  const isEn = (i18n.resolvedLanguage || i18n.language || '').toLowerCase().startsWith('en');

  return (
    <div style={{display: 'none'}} aria-hidden="true">
      <div style={containerStyle} aria-label="Language Switcher">
        <button
          onClick={() => changeLang('es')}
          style={isEs ? {...linkStyle, ...activeLangStyle} : linkStyle}
        >
          ES
        </button>
        <span style={{color: '#999'}}>|</span>
        <button
          onClick={() => changeLang('en')}
          style={isEn ? {...linkStyle, ...activeLangStyle} : linkStyle}
        >
          EN
        </button>
      </div>
    </div>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Suspense fallback={null}>
          <LanguageSwitcher/>
          <Routes>
            <Route path="/" element={<Login/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route path="/register" element={<Register/>}/>
            <Route element={<ProtectedLayout/>}>
              <Route path="/logout" element={<Logout/>}/>
              <Route path="/upload" element={<FileUpload/>}/>
              <Route path="/forecast" element={<Forecast/>}/>
              <Route path="/treemap" element={<TreemapView/>}/>
              <Route path="/dashboard" element={<Dashboard/>}/>
              <Route path="/installments" element={<Installments/>}/>
              <Route path="/expenses" element={<Expenses/>}/>
              <Route path="/goals" element={<Budgets/>}/>
              <Route path="/transfers" element={<Transfers/>}/>
              <Route path="/subscriptions" element={<Subscriptions/>}/>
              <Route path="/tags" element={<Tags/>}/>
            </Route>
          </Routes>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;